/* eslint-disable no-undef */
const GA_MEASUREMENT_ID = process.env.REACT_APP_G_TAG_ID; // replace with your GA4 ID

export const initGA = () => {
    if (!window.gtagLoaded) {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
        script.onload = () => {
            window.dataLayer = window.dataLayer || [];
            function gtag() { window.dataLayer.push(arguments); }
            window.gtag = gtag;
            gtag('js', new Date());
            gtag('config', GA_MEASUREMENT_ID);

            window.gtagLoaded = true;
        };
        document.head.appendChild(script);
    }
};

export const pageView = (path, title) => {
    if (window.gtagLoaded && window.gtag) {
        console.log(`Page view: ${path} - Title: ${title}`);
        
        window.gtag('event', 'page_view', {
            page_path: path,
            page_title: title,
            send_page_view: true
        });
    }
};